/**
 * Reference Code Mapping for Plot Service
 * Maps field names to Evaluate codes (resourceCode in Item Library API)
 */

export interface PlotServiceReferenceCodeMapping {
  code?: string;
}

/**
 * Plot Service Reference Codes
 * Maps field names from plot service tables to Evaluate codes
 */
export const PLOT_SERVICE_REFERENCES: Record<
  string,
  PlotServiceReferenceCodeMapping
> = {
  // Plot Services
  plots: { code: "GWALPDS006" },
  apartments: { code: "GWALPDS006" },
  eo25mmBarrierPipe: { code: "GWALPDS010" },
  eo32mmBarrierPipe: { code: "GWALPDS011" },
  virginMedia: { code: "GWALPDS007A" },
  garageDuct: { code: "GWALPDS004" },
  privateStLightDuct: { code: "GWALPDS005" },
  pccEdgingsGasBoxes: { code: "GWALPDS009" },
  ductingToChargingPoint: { code: "GWALPDS005" },
  concBaseChargingPoints: { code: "GWALPDS015" },
  installBollardBase: { code: "GWALPDS016" },
  airSourceHeatPump: { code: "GWALPDS017"},
  // Service Connections
  serviceConnectionPlots: { code: "GWALPDS007" },
  serviceConnectionApartments: { code: "GWALPDS007" },
  vacEx: {code: "GWALPDS003"},
};

/**
 * Get reference code for a specific field
 */
export const getPlotServiceReferenceCode = (
  referenceKey: string,
): string | undefined => {
  return PLOT_SERVICE_REFERENCES[referenceKey]?.code;
};

/**
 * Get full reference information for a specific field
 */
export const getPlotServiceReference = (
  referenceKey: string,
): PlotServiceReferenceCodeMapping | undefined => {
  return PLOT_SERVICE_REFERENCES[referenceKey];
};
